import http from ".././http-common.js";

export default {
  authenticate(payload) {
    return http.post("/api/token/", payload).then(res => {
      return res;
    });
  }
};
